<template>
    <ValidationObserver ref="observer"
                        tag="form"
                        class="mx-2"
                        @submit.prevent="submit">
        <div class="row d-flex">
            <div class="col-sm-6 py-4">
                <ValidationProvider tag="div"
                                    class="mb-4"
                                    vid="name"
                                    mode="lazy"
                                    :customMessages="{required: 'Norādi kategorijas nosaukumu.'}"
                                    rules="required"
                                    v-slot="{errors}">
                    <label for="name" class="d-block text-secondary text-left mb-0">Nosaukums</label>
                    <input type="text" id="name" class="w-100 py-1 ds-input" v-model="category.name"
                           :disabled="category.isTemplate">
                    <span class="text-danger d-block text-left small mt-1">{{ errors[0] }}</span>
                </ValidationProvider>
                <ValidationProvider tag="div"
                                    vid="isActive"
                                    mode="lazy"
                                    rules="required"
                                    v-slot="{errors}">
                    <b-form-checkbox v-model="category.isActive" name="isActive" switch size="md" :disabled="category.isTemplate">
                        Aktīvs
                    </b-form-checkbox>
                    <span class="text-danger d-block text-left small mt-1">{{ errors[0] }}</span>
                </ValidationProvider>
            </div>
            <div class="col-sm-6 py-4 text-center">
                <h4 class="text-center mt-4 mb-0">Darbinieku grupas</h4>
                <ValidationProvider v-if="usersGroupsOptions.length"
                                    tag="div"
                                    vid="userGroup"
                                    class="mb-4"
                                    mode="lazy"
                                    :customMessages="{required: 'Norādi darbinieka grupu.'}"
                                    v-slot="{errors}">
                    <b-form-group class="text-left mt-4">
                        <b-form-checkbox-group
                                id="userGroup"
                                v-model="selectedUsersGroups"
                                :options="usersGroupsOptions"
                                name="flavour-2a"
                                stacked
                        />
                    </b-form-group>

                    <span class="text-danger d-block text-left small mt-1">{{ errors[0] }}</span>
                </ValidationProvider>
            </div>
        </div>
        <CustomButton class="w-25 mb-4 ds-btn--success" btn-text="Saglabāt izmaiņas" :is-loading="isActiveRequest"/>
    </ValidationObserver>
</template>
<script>
    import {mapActions, mapGetters, mapMutations} from 'vuex';

    import {extend, ValidationObserver, ValidationProvider} from 'vee-validate';
    import {required} from 'vee-validate/dist/rules';

    import CustomButton from '@/components/global/CustomButton';
    import {Category} from '../../vuex/modules/category/models/category.models';
    import * as categoryStoreTypes from '../../vuex/modules/category/category.store-types';
    import * as companyStoreTypes from '../../vuex/modules/company/company.store-types';
    import * as rootStoreTypes from '../../vuex/root.store-types';

    export default {
        name: 'categories-base-form',
        components: {
            CustomButton,
            ValidationProvider,
            ValidationObserver,
        },
        props: {
            currentCategory: {
                type: Category,
                required: false,
                default: () => new Category,
            },
        },
        data() {
            return {
                selectedUsersGroups: [],
                category: {...this.currentCategory}
            }
        },
        created() {
            const list = this.currentCompany.usersGroups.map(({_id}) => _id.toString());

            this.selectedUsersGroups = this.category.usersGroups
                .filter(({userGroup}) => list.includes(userGroup.toString()))
                .map(({userGroup}) => userGroup.toString());

            extend('required', required);
        },
        computed: {
            ...mapGetters('category', {
                /** @type {boolean|*} */
                isActiveRequest: categoryStoreTypes.GET_IS_ACTIVE_REQUEST,
            }),
            ...mapGetters('company', {
                /** @type {Company|*} */
                currentCompany: companyStoreTypes.GET_CURRENT_COMPANY,
            }),
            usersGroupsOptions() {
                return this.currentCompany.usersGroups.map(({_id, name}) => ({value: _id, text: name}));
            },
        },
        methods: {
            ...mapMutations({
                /** @type {function|*} */
                setAlertData: rootStoreTypes.SET_ALERT_DATA,
            }),
            ...mapActions('category', {
                /** @type {function|*} */
                createCategory: categoryStoreTypes.ACTION_CREATE_CATEGORY,
                /** @type {function|*} */
                updateCategory: categoryStoreTypes.ACTION_UPDATE_CATEGORY,
            }),
            async submit() {
                const isValid = await this.$refs.observer.validate();

                if (!isValid) {
                    return;
                }

                try {
                    const data = {
                        category: this.category,
                        selectedCompanies: [this.currentCompany._id],
                        selectedUsersGroups: this.selectedUsersGroups,
                    };

                    if (this.category._id) {
                        await this.updateCategory(data);

                        return this.updateStatus('Kategorijas izmaiņas saglabātas!');
                    }

                    await this.createCategory(data);

                    this.reset();
                } catch (error) {
                    this.$refs.observer.setErrors({[error.field]: [error.message]});
                }
            },
            updateStatus(message) {
                this.setAlertData({type: 'primary', message});
                this.$emit('finished');
            },
            reset() {
                this.category = new Category;
                this.$refs.observer.reset();
                this.updateStatus('Kategorija pievienota!');
            },
        }
    }
</script>